module.exports = __webpack_public_path__ + "static/media/Chaafo.24651abe.png";